//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    page: {
      type: String,
      required: true
    }
  },
  computed: {
    buttonSize () {
      return this.isTablet() ? 'sm' : 'md'
    }
  },
  methods: {
    onClick () {
      if (this.page === 'improvement_program') {
        location.href = '/quiz-gifting'
      } else {
        location.hash = ''
        location.hash = '#test-plans'
      }
    }
  }
}
